(function () {

  window.bundle = {
    items: [false,false,false],
    total: 0 
  }
	
  function updatePrice(e,variant) {
    
    const price = variant.price;
    
    
    const originalPriceEl = e.querySelector('.bundle-item__price-original');
    const salePriceEl = e.querySelector('.bundle-item__price-sale');
    const savingsEl = e.querySelector('.bundle-item__savings');
    
    const savings = (price / 100) * 20;
    const salePrice = price - savings;
    
    
    salePriceEl.innerHTML = Shopify.formatMoney(salePrice).replace('.00','');
    originalPriceEl.innerHTML = Shopify.formatMoney(price).replace('.00','');
    savingsEl.innerHTML = Shopify.formatMoney(savings).replace('.00','');

    
  }
  
  function getColorSwatches(title,e) {
    fetch(`/search?q=title:${title}&view=swatch-metafields&type=product`)
    .then((response) => response.json())
    .then((swatches) => {
      console.log(swatches);
      if(swatches.length) {
        swatches.forEach(swatch => {
          console.log(swatch);
        });
      }
    })
  }
  
  function toHandle(str) {
    return str.toLowerCase().replace(/ /g,'-');
  }
  
  function getColors(title,e) {
    const colorList = e.target.closest('.bundle-item').querySelector('.bundle-item__colors');
    const priceEl = e.target.closest('.bundle-item').querySelector('.bundle-item__price-wrapper');
    
    colorList.innerHTML = '';
    
	let foundOne = false;
    let activeColor = false;
    
    fetch(`/search?q=title:${title}&view=api&type=product`)
    .then((response) => response.json())
    .then((suggestions) => {
      
      suggestions.forEach(product => {
        
        if(product.tags.indexOf('MENS') > -1) return;
        if(product.vendor == 'MONROW ARCHIVES') return;
        if(product.title != title) return;
        
        const colorIndex = product.options.indexOf('Color');
        const colorName = product.variants[0].options[colorIndex];
        const swatch = document.createElement("button");
        swatch.classList.add('bundle-swatch');
        swatch.classList.add('bundle-swatch__color');
        swatch.classList.add(`bundle-swatch__${toHandle(colorName)}`);
        swatch.setAttribute('data-color',colorName);
        swatch.innerHTML = `<span class="visually-hidden">${colorName}</span>`;
        swatch.setAttribute('data-json',JSON.stringify(product));
        colorList.appendChild(swatch);
        if(!foundOne) {
          updatePrice(e.target.closest('.bundle-item').querySelector('.bundle-item__price-wrapper'),product.variants[0]);
          foundOne = true;
        }
        if(product.tags.indexOf('BUNDLE_TOPS') > -1) {
          activeColor = product.variants[0].options[colorIndex];
          swatch.click();
        }
        if(product.tags.indexOf('BUNDLE_SWEATSHIRTS') > -1) {
          activeColor = product.variants[0].options[colorIndex];
          swatch.click();
        }
        if(product.tags.indexOf('BUNDLE_BOTTOMS') > -1) {
          activeColor = product.variants[0].options[colorIndex];
          swatch.click();
        }
        
      });
      
      priceEl.style.display = 'flex';
      
      colorList.closest('.bundle-item__option').style.display = 'block';
      
      getColorSwatches(title,e);

    })
  }
  
  function getSizes(e) {
    const sizeList = e.target.closest('.bundle-item').querySelector('.bundle-item__sizes');
    sizeList.innerHTML = '';
    
    const json = JSON.parse(e.target.getAttribute('data-json'));
    const sizeIndex = json.options.indexOf('Size');
    json.variants.forEach((variant) => {
      const mySize = variant.options[sizeIndex];
      const swatch = document.createElement('button');
      const availableClass = variant.available ? 'available' : 'sold-out';
      
      swatch.classList.add('bundle-swatch');
      swatch.classList.add('bundle-swatch__size');
      swatch.classList.add(availableClass);
      if(!variant.available) swatch.setAttribute('disabled','disabled');
      swatch.setAttribute('data-id',variant.id);
      swatch.setAttribute('data-variant',JSON.stringify(variant));
      swatch.textContent = mySize;
      sizeList.appendChild(swatch);
      
    });
    sizeList.closest('.bundle-item__option').style.display = 'block';
  }
  
  
  
  function updateImage(e) {
    const bundleImage = e.target.closest('.bundle-item').querySelector('.bundle-item__image img');
    const json = JSON.parse(e.target.getAttribute('data-json'));
    bundleImage.setAttribute('src',json.featured_image);
  }
  
  
  const bundleStyleSelects = document.querySelectorAll('.bundle-style-select');
  bundleStyleSelects.forEach((select) => {
    select.addEventListener('change',(e) => {
      const title = e.target.options[e.target.selectedIndex].textContent;      
      getColors(title,e);
    });
  });
  
  function hideAddButton(e) {
    const bundleButton = e.target.closest('.bundle-item').querySelector('.add-to-bundle');
    if(bundleButton) {
      bundleButton.style.display = 'none';
    }
  }
  
  function showAddButton(e) {
    const bundleButton = e.target.closest('.bundle-item').querySelector('.add-to-bundle');
    if(bundleButton) {
      bundleButton.style.display = 'block';
    }
  }
  
  function updateAddButton(val) {
    
  }
  
  function updatePreview() {
    let subtotal = 0;
    let goodToGo = true;
    
    window.bundle.items.forEach((item,idx) => {
      
      if(!item) goodToGo = false;
      if(item) {
        subtotal = subtotal + item.price;
        
        const bundleEl = document.querySelector(`.bundle-preview__item-${idx}`);
        const img = document.querySelectorAll('.bundle-item__image')[idx].querySelector('img');
        
        
        bundleEl.querySelector('.bundle-preview__image').setAttribute('src',img.getAttribute('src'));
        bundleEl.querySelector('.bundle-preview__title').textContent = item.name.split(' - ')[0];
        
		const itemSavings = (item.price / 100) * 20;
        const itemPrice = item.price - itemSavings;
        bundleEl.querySelector('.bundle-preview__price').textContent = Shopify.formatMoney(itemPrice);
        
        bundleEl.querySelector('.bundle-preview__variants').innerHTML = `
		Color: ${item.option2}<br>
		Size: ${item.option1}
		`;
        
        bundleEl.classList.add('added');

        
      }
    });
      
    
    const savings = (subtotal / 100) * 20;
    const salePrice = subtotal - savings;
    
    const subtotalEl = document.querySelector('.set-subtotal');
    const savingsEl = document.querySelector('.set-savings');
    
    subtotalEl.textContent = Shopify.formatMoney(salePrice);
    savingsEl.textContent = Shopify.formatMoney(savings);
    
    const addButtonDisplay = goodToGo ? 'block' : 'none';
    document.querySelector('.add-set-to-bag').style.display = addButtonDisplay;
    document.querySelector('.scroll-to-set').style.display = addButtonDisplay;
    
    window.bundle.total = salePrice;
    
  }
  
  function saveBundle() {
    window.localStorage.setItem("bundle",JSON.stringify(window.bundle));
  }
  
  function onBundleAdded() {
    const cartDrawer = document.querySelector('cart-drawer');
    
    document.getElementById('mini-cart').style.opacity = 1;
    document.getElementById('mini-cart').style.visibility = 'visible';
    
    document.getElementById('mini-cart-toggle').style.opacity = 1;
    document.getElementById('mini-cart-toggle').style.visibility = 'visible';
    
    document.querySelector('body').style.overflow = 'auto';
    
    
    
  }
  
  function addBundleToCart() {
    const bundleItemArray = [];
    const now =  'bundle_'+Math.floor(Date.now() / 1000);

    window.bundle.items.forEach((item) => {
      const bundleItem = {
        id: item.id,
        quantity: 1,
        properties: {
          "_bundle": true,
          "_bundle_total": window.bundle.total,
          "bundle_id": now
        }
      };
      if(item.id == this.giftReceiptId) {
        bundleItem.properties["Gift Note"] = item.giftNote;
      }
      bundleItemArray.push(bundleItem);  
    });
    

    let bundleData = {
      'items': bundleItemArray
    };

    
    bundleData.sections = "cart-drawer,cart-icon-bubble,main-cart-items";
    bundleData.sections_url = "/cart?sections=cart-drawer,cart-icon-bubble,main-cart-items";

    


    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(bundleData)
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      console.log(data);
      cartUpdate(data);
      const cartDrawer = document.querySelector('cart-drawer .header__icon--summary');
      if(cartDrawer) {
        cartDrawer.click();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  
  document.querySelector('.add-set-to-bag').addEventListener('click',(e) => {
    e.preventDefault();
    addBundleToCart();
  });
  
  document.addEventListener('click',(e) => {
    if(e.target && e.target.classList.contains('bundle-swatch__color')) {
      e.target.closest('.bundle-item__colors').querySelectorAll('.bundle-swatch').forEach((swatch) => {
        swatch.classList.remove('selected');
      });
      e.target.classList.add('selected');
      e.target.closest('.bundle-item__option').querySelector('.selected_option').textContent = `- ${e.target.getAttribute('data-color')}`;
      const json = JSON.parse(e.target.getAttribute('data-json'));
      getSizes(e);
      updateImage(e);
      updatePrice(e.target.closest('.bundle-item').querySelector('.bundle-item__price-wrapper'),json.variants[0]);
      hideAddButton(e);
    }
    
    if(e.target && e.target.classList.contains('bundle-swatch__size')) {
      const sizeList = e.target.closest('.bundle-item__sizes'); 
      sizeList.querySelectorAll('.bundle-swatch').forEach((swatch) => {
        swatch.classList.remove('selected');
      });
      e.target.classList.add('selected');
      e.target.closest('.bundle-item__option').querySelector('.selected_option').textContent = `- ${e.target.textContent}`;
      const bundleButton = e.target.closest('.bundle-item').querySelector('.add-to-bundle');
      bundleButton.setAttribute('data-id',e.target.getAttribute('data-id'));
      bundleButton.setAttribute('data-variant',e.target.getAttribute('data-variant'));
      const json = JSON.parse(e.target.getAttribute('data-variant'));
      bundleButton.textContent = 'Add to set';
      updatePrice(e.target.closest('.bundle-item').querySelector('.bundle-item__price-wrapper'),json);
      showAddButton(e);
    }
  });
  
  const addButtons = document.querySelectorAll('.add-to-bundle');
  addButtons.forEach((button,idx) => {
    button.addEventListener('click',(e) => {
      const variant = JSON.parse(button.getAttribute('data-variant'));
      window.bundle.items[idx] = variant;
      console.log(window.bundle);
      button.textContent = 'Added to set';
      updatePreview();
    });
  });
  
  document.querySelector('.scroll-to-set').addEventListener('click',(e) => {
    const preview = document.querySelector('.bundle-preview');
    preview.scrollIntoView();
  });
//   const bundleSwatches = document.querySelectorAll('.bundle-swatch');
//   bundleSwatches.forEach((swatch) => {
//     swatch.addEventListener('click',(e) => {
      
//     });
//   });
  
})();


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};